<div class="section-title">
    <div class="input-group">
        <input type="text" class="form-control marathi-font" [(ngModel)]="searchTextLocal"
            placeholder="शब्द/वाक्य शोधा (Search by word/phrase)" #searchtext>
        <button class="btn btn-outline-secondary" type="button" (click)="search(searchtext)">
            <i class="bi bi-search"></i></button>
        <button class="btn btn-outline-secondary" type="button" (click)="clear(searchtext)">
            <i class="bi bi-arrow-clockwise"></i>
        </button>
    </div>

    <div>
        <div class="form-check form-check-inline mt-2" *ngIf="enableGlobalSearch">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" checked id="inlineRadio1"
                value="option1">
            <label class="form-check-label" for="inlineRadio1">In-page Search</label>
        </div>
        <div class="form-check form-check-inline" *ngIf="enableGlobalSearch">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
            <label class="form-check-label" for="inlineRadio2">Global Search</label>
        </div>
    </div>
</div>
<div class="accordion" id="accordionExample">
    <div class="accordion-item" [id]='"divid"+i' *ngFor="let item of filteredItems | async ; let i = index">
        <h2 class="accordion-header" [id]='"headingOne"+i' (click)="scroll('headingOne'+i)">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                [attr.data-bs-target]='"#id"+i' aria-expanded="false" [attr.aria-controls]='"id"+i'>

                <span class="marathi-font-lg"><i class="bi bi-caret-right-fill"></i> {{ item.title}}</span>                
            </button>
        </h2>
        <div [id]='"id"+i' class="accordion-collapse collapse" [attr.aria-labelledby]='"headingOne"+i'
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p class="marathi-font" [innerHTML]="item.body"></p>
                <p><button [id]='"b"+i' style="border: 0px;" class="default-button" (click)="captureScreen('divid'+i)"><i class="bi bi-download"></i> Download as PDF</button></p>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center mt-5" *ngIf="loaderVisable | async">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>